export default __webpack_public_path__ + "static/media/IMG-20240729-WA0028.5f1e20b9.jpg";